import React from 'react';
import {Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {
	AccordionHeader,
	CustomAccordion,
	CustomAccordionDetails,
	CustomAccordionSummary,
} from './styles';
import {cardStyleByStatus, chipByStatus} from '../../constants/accordionByStatus';
import {AccordionWithStatusProps} from './types';

export const AccordionWithStatus = ({
	title,
	status,
	children,
	expanded,
	onChange,
	removeBgColor = false,
	noPadding,
	onClick,
	removeIcon,
	cursor = 'pointer',
}: AccordionWithStatusProps) => (
	<CustomAccordion
		onClick={onClick}
		square
		expanded={expanded}
		onChange={onChange}
		$removeBgColor={removeBgColor}
		$cursor={cursor}>
		<CustomAccordionSummary
			expandIcon={!removeIcon ? <Icon name="expand-more-filled" /> : null}
			aria-controls="panel1-content"
			id="panel1-header"
			$variant={cardStyleByStatus[status].$variant}>
			<AccordionHeader>
				<Typography
					fontSize={'1.25rem'}
					fontWeight={600}
					color={cardStyleByStatus[status].textColor}>
					{title}
				</Typography>
				<Typography
					fontSize={'0.875rem'}
					fontWeight={600}
					color={cardStyleByStatus[status].textColor}>
					{chipByStatus[status].label}
				</Typography>
			</AccordionHeader>
		</CustomAccordionSummary>
		<CustomAccordionDetails $noPadding={noPadding}>{children}</CustomAccordionDetails>
	</CustomAccordion>
);
